export const removeNonNumericMask = (input) => {
  if (!input) {
    return ''
  }

  return input.replace(/\D/g, '')
}
